import React from 'react'
import { QRCode } from 'react-qrcode-logo'
import { useTrackMutation } from '@mote/api'
import { TRACK_EVENT_NAMES } from '../../../helpers/constants'
import { getResourceFile } from '../../misc'

export const useMoteQrCode = ({
  moteId,
  url,
  size = 135,
  logoImage = getResourceFile('/images/logos/mote-round-white.png'),
  logoSize = 32,
  renderFor = 'extension',
  ...rest
}) => {
  const containerRef = React.useRef(null)
  const { mutate: track } = useTrackMutation()

  const saveImage = React.useCallback(() => {
    const canvas = containerRef.current?.querySelector('canvas')

    if (!canvas) return

    const link = document.createElement('a')
    link.download = `mote-qr-${moteId}.png`
    link.href = canvas.toDataURL('image/png')
    link.click()

    track({
      variables: {
        event: TRACK_EVENT_NAMES.sharePanel.action,
        action: 'QR-image-saved'
      }
    })
  }, [moteId])

  const getImagesProps = React.useCallback(() => {
    if (!containerRef.current) return { src: null }

    const canvas = containerRef.current.querySelector('canvas')

    if (!canvas) return { src: null }

    const src = canvas.toDataURL('image/png')
    const height = +canvas.height / 2
    const width = +canvas.width / 2

    return { src, width, height }
  }, [])

  return {
    saveImage,
    qrCodeElement: (
      <QRCode
        size={size}
        value={url}
        logoImage={logoImage}
        logoHeight={logoSize}
        logoWidth={logoSize}
        {...rest}
      />
    ),
    qrCodeImageElement: (
      <img
        {...getImagesProps()}
        alt='Mote QR Code'
        style={{
          position: 'absolute',
          zIndex: 1,
          opacity: 0,
          cursor: 'pointer'
        }}
      />
    ),
    renderFor,
    containerRef
  }
}
